const GENERIC_TREND_TEXT_PATTERNS = [
  /^här börjar modulens andra lager/i,
  /^detta bör tolkas som ett tema snarare än en enskild artikel/i,
  /^bedöm hur temat/i,
  /^avgör om temat/i,
  /^validera temat mot fontanas prioriterade kategorier/i,
  /^formulera ett recept- eller serveringsspår/i,
  /^om det är relevant[: ]/i,
];

const GENERIC_PRODUCT_CONNECTION_PATTERNS = [
  /^testa om temat kan aktiveras med /i,
];

const GENERIC_RECIPE_CONNECTION_PATTERNS = [
  /^översätt signalen till ett grekiskt eller medelhavsinspirerat recept/i,
];

const GENERIC_ACTION_PATTERNS = [
  /^validera temat mot fontanas prioriterade kategorier/i,
  /^formulera ett recept- eller serveringsspår som kan testas redaktionellt/i,
  /^avgör om temat ska följas som design- eller förpackningsbevakning/i,
  /^identifiera om det påverkar premiumuttryck, etikett eller hyllkommunikation/i,
  /^avgör om temat påverkar kategoriroll, positionering eller konkurrensbild/i,
  /^prioritera om det kräver vidare analys/i,
  /^avgör först om temat är tillräckligt starkt/i,
  /^om det är relevant[: ]/i,
];

function normalizeTrendDisplayText(value: unknown): string {
  return String(value || '')
    .replace(/\s+/g, ' ')
    .trim();
}

function matchesAnyPattern(value: string, patterns: RegExp[]): boolean {
  return patterns.some((pattern) => pattern.test(value));
}

export function getMeaningfulTrendText(
  value: unknown,
  options?: { minLength?: number; extraPatterns?: RegExp[] },
): string {
  const normalized = normalizeTrendDisplayText(value);
  const minLength = Math.max(0, Number(options?.minLength || 0));
  const patterns = [
    ...GENERIC_TREND_TEXT_PATTERNS,
    ...(Array.isArray(options?.extraPatterns) ? (options?.extraPatterns || []) : []),
  ];

  if (!normalized) return '';
  if (normalized.length < minLength) return '';
  if (matchesAnyPattern(normalized, patterns)) return '';
  return normalized;
}

export function hasMeaningfulTrendText(
  value: unknown,
  options?: { minLength?: number; extraPatterns?: RegExp[] },
): boolean {
  return Boolean(getMeaningfulTrendText(value, options));
}

export function filterMeaningfulTrendStrings(
  values: unknown,
  kind: 'text' | 'product' | 'recipe' | 'action' = 'text',
): string[] {
  const specificPatterns = kind === 'product'
    ? GENERIC_PRODUCT_CONNECTION_PATTERNS
    : kind === 'recipe'
      ? GENERIC_RECIPE_CONNECTION_PATTERNS
      : kind === 'action'
        ? GENERIC_ACTION_PATTERNS
        : [];

  return Array.isArray(values)
    ? values
      .map((entry) => normalizeTrendDisplayText(entry))
      .filter(Boolean)
      .filter((entry) => !matchesAnyPattern(entry, [...GENERIC_TREND_TEXT_PATTERNS, ...specificPatterns]))
    : [];
}
